import React from 'react';

import { Group } from '@mantine/core';
import { DateInput } from '@mantine/dates';

interface IAthleteCreditsFilterProps {
  validityDate: Date;
  setValidityDate: (date: Date) => void;
}

const AthleteCreditsFilter = ({
  validityDate,
  setValidityDate,
}: IAthleteCreditsFilterProps): JSX.Element => {
  const handleDateChange = (date: Date): void => {
    setValidityDate(date);
  };

  return (
    <Group noWrap position='apart' px='xl'>
      <DateInput value={validityDate} onChange={handleDateChange} label='Validity Date' />
    </Group>
  );
};

export default AthleteCreditsFilter;
